import { faArrowLeft, faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@heroui/react';
import { useRouter } from '@tanstack/react-router';

export default function DefaultError() {
    const router = useRouter();
    return (
        <div className='flex flex-col items-center justify-center '>
            <h1 className='text-2xl font-semibold'>Something went wrong</h1>
            <div className='flex flex-row items-center gap-2'>
                <Button
                    color='primary'
                    size='sm'
                    onPress={() => router.navigate({ to: '..' })}
                    startContent={<FontAwesomeIcon icon={faArrowLeft} />}>
                    Go Back
                </Button>
                <Button
                    size='sm'
                    onPress={() => window.location.reload()}
                    startContent={<FontAwesomeIcon icon={faRotateLeft} />}>
                    Reload
                </Button>
            </div>
        </div>
    );
}
